/* tslint:disable */
import {
  StockLocation
} from '../index';

declare var Object: any;
export interface StockWarehouseInterface {
  "id"?: number;
  "name": string;
  "wh_input_stock_loc_id"?: number;
  "wh_qc_stock_loc_id"?: number;
  "wh_pack_stock_loc_id"?: number;
  "wh_output_stock_loc_id"?: number;
  "sam_stock_loc_id"?: number;
  "pbm_stock_loc_id"?: number;
  whInput?: StockLocation;
  whQc?: StockLocation;
  whPack?: StockLocation;
  whOutput?: StockLocation;
  whSam?: StockLocation;
  whPbm?: StockLocation;
}

export class StockWarehouse implements StockWarehouseInterface {
  "id": number;
  "name": string;
  "wh_input_stock_loc_id": number;
  "wh_qc_stock_loc_id": number;
  "wh_pack_stock_loc_id": number;
  "wh_output_stock_loc_id": number;
  "sam_stock_loc_id": number;
  "pbm_stock_loc_id": number;
  whInput: StockLocation;
  whQc: StockLocation;
  whPack: StockLocation;
  whOutput: StockLocation;
  whSam: StockLocation;
  whPbm: StockLocation;
  constructor(data?: StockWarehouseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockWarehouse`.
   */
  public static getModelName() {
    return "StockWarehouse";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockWarehouse for dynamic purposes.
  **/
  public static factory(data: StockWarehouseInterface): StockWarehouse{
    return new StockWarehouse(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockWarehouse',
      plural: 'StockWarehouses',
      path: 'StockWarehouses',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "wh_input_stock_loc_id": {
          name: 'wh_input_stock_loc_id',
          type: 'number'
        },
        "wh_qc_stock_loc_id": {
          name: 'wh_qc_stock_loc_id',
          type: 'number'
        },
        "wh_pack_stock_loc_id": {
          name: 'wh_pack_stock_loc_id',
          type: 'number'
        },
        "wh_output_stock_loc_id": {
          name: 'wh_output_stock_loc_id',
          type: 'number'
        },
        "sam_stock_loc_id": {
          name: 'sam_stock_loc_id',
          type: 'number'
        },
        "pbm_stock_loc_id": {
          name: 'pbm_stock_loc_id',
          type: 'number'
        },
      },
      relations: {
        whInput: {
          name: 'whInput',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'wh_input_stock_loc_id',
          keyTo: 'id'
        },
        whQc: {
          name: 'whQc',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'wh_qc_stock_loc_id',
          keyTo: 'id'
        },
        whPack: {
          name: 'whPack',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'wh_pack_stock_loc_id',
          keyTo: 'id'
        },
        whOutput: {
          name: 'whOutput',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'wh_output_stock_loc_id',
          keyTo: 'id'
        },
        whSam: {
          name: 'whSam',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'sam_stock_loc_id',
          keyTo: 'id'
        },
        whPbm: {
          name: 'whPbm',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'pbm_stock_loc_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockWarehouse.ts